module.exports = __webpack_public_path__ + "img/capa-hover-saude.b16287b2.png";